import React, { use, useEffect, useRef, useState } from "react";
import Cookies from 'js-cookie';
import { TextField, Checkbox, FormControlLabel, Button, Typography, Box, InputAdornment, Grid, Paper, IconButton, Alert, FormControl, Dialog, DialogTitle, Chip, DialogContent, DialogActions } from "@mui/material";
import { useForm } from "react-hook-form";
import loginIllustration from ".././graphic.svg";
import '../../Components/LoginForm.css';
import { IconEye, IconEyeOff, IconLogin2, IconX } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import ReCAPTCHA from "react-google-recaptcha";
import PageContainer from "../Pages/Pagecontainer";
// import Logo from '.././Images/logo1.png'
import Logo from '.././Images/logo-dark.png'

import Billing from "../Pages/Billing";
const LoginForm = () => {
  const recaptchaRef = useRef(null);
  const { register, handleSubmit, formState: { errors }, trigger, setValue, clearErrors ,getValues,watch} = useForm();
  const { register:Billingregister, handleSubmit:BillingSubmit, formState: { errors:billingerrors}, trigger:BillingTrigger, setValue:BillingValue, clearErrors:Billingerrors,getValues:BillingValues,watch :BillingWatch} = useForm();
  const navigate = useNavigate()
  const [Apierror, setApiError] = useState('')
  const [ActivationError,setActivationError]= useState('')
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [verify,setverify]= useState('') 
  const [resendmail, setresendmail] = useState('')
  const [loader, setLoader] = useState(false);
  const onSubmit = async (data) => {
    // const token = recaptchaRef.current.getValue();

    // if (!token) {
    //   setApiError("Please complete the reCAPTCHA.");
    //   return;
    // }
    try {
      setLoading(true);
      setresendmail("")
      let req = {
        email: data.email,
        password: data.password,
      };
      if (data.rememberMe) {
        sessionStorage.setItem("username", data.email)
        sessionStorage.setItem("Password", data.password)
        sessionStorage.setItem("rememberMe", data.rememberMe)
      } else {
        sessionStorage.removeItem("username")
        sessionStorage.removeItem("Password")
        sessionStorage.removeItem("rememberMe")
      }
      const response = await axios.post('/apiV1/login/', req);
      if (response.status === 200) {
        sessionStorage.setItem("AdminToken", response.data.access)
        const token = response.data.access;
              Cookies.set('AdminToken', token);
        await userInfo()
        setLoading(false);
        // navigate('/dashboard');
      }
    } catch (error) {
      setApiError(error?.response?.data?.detail?.[0]);
      setActivationError(error?.response?.data?.message?.[0]);
      setverify(error?.response?.data?.is_verified);
      setLoading(false);
    }

  };
  const [billingStatus, setBillingStatus] = useState('');
  
  const userInfo = async () => {
    try {
      const config = axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("AdminToken")}` }
      const response = await axios.get('/apiV1/user-info/', config);
      console.log(response.data);
      if (response.status == 200) {
        sessionStorage.setItem("user-info", JSON.stringify(response.data))
        setBillingStatus(response.data)
        Cookies.set('user-info', JSON.stringify(response.data));
      }
    } catch (error) {
      console.error('Error generating test:', error.response ? error.response.data : error.message);
    }
  }
  useEffect(() => {
    const savedEmail = sessionStorage.getItem('username');
    const savedPassword = sessionStorage.getItem('Password');
    const rememberMe = sessionStorage.getItem('rememberMe') === "true" ? true : false;
    setValue('rememberMe', rememberMe);
    if (savedEmail && savedPassword) {
      setValue('email', savedEmail);
      setValue('password', savedPassword);
    }
  }, []);
  const postCaptcha = async (token) => {
    try {
      let req = {
        recaptcha_token: token
      }
      const response = await axios.post('/apiV1/protected/',req);
      console.log(response);
    }
    catch (error) {
      console.log('Error generating test:', error.response ? error.response.data : error.message);
    }
  }
  const ResendEmail =async()=>
    {
      setActivationError("")
      setLoading1(true)
      let req={
        phone:getValues("email")
      }
      try
      {
        const response = await axios.post('/apiV1/resend-otp-email/',req)
        if (response.status == 200) {
            setresendmail(response.data.message)
            setLoading1(false)
            setApiError('')
            setverify("")
        }
        
      }catch(error)
      {
        console.log(error)
        setActivationError(error.response.data.message)
        setLoading1(false)
      }
    }
    const [BillingPopup, setBillingPopup] = useState(false);
    useEffect(() => {
        if (billingStatus?.is_billing_added === false) {
            BillingValue('email', billingStatus?.email);
            const nameParts = billingStatus?.fullname?.trim().split(" ") || [];
            const firstName = nameParts[0] || "";
            const lastName = nameParts.slice(1).join(" ") || "";
            BillingValue('firstName', billingStatus?.first_name);
            BillingValue('lastName', billingStatus?.last_name);
            BillingValue('mobile', billingStatus?.mobile);
            setBillingPopup(true);
        }
        else if (billingStatus?.is_billing_added === true) {
          navigate('/dashboard');
        }
    }, [billingStatus]);
    const onBillingSubmit = async (data) => {
      console.log(data);
      setLoader(true)
      const req = {
        "user_id": billingStatus?.id,
        "user_info":[
          {
              name:data.firstName + " " + data.lastName,
              full_name:data.firstName + " " + data.lastName,
              mobile:data.mobile,
          }
      ],
        "adress_info": [
            {
                // id:  billingStatus?.id,
                // name: data.firstName + " " + data.lastName,
                first_name: data.firstName,
                last_name: data.lastName,
                address_line_1: data.addressLine1,
                address_line_2: data.addressLine2,
                city: data.city,
                state: data.state,
                postal_code: data.zipCode,
                country: data.country,
                phone_number: data.mobile,
                address_type: "BILLING"
            }
        ]
      }
      try{
        const config2 = {
          headers: {
              Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
          },
      };
          const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/update-billing_address/`,req,config2);
          if (response.status == 200 || response.status == 201) {
            setBillingPopup(false);
            updateBillingStatus()
            navigate('/dashboard');
            setLoader(false);
          }
       
        }catch(error){
          console.log(error)
          setLoader(false);
        }
    }
  const updateBillingStatus = async () => {
    try {
      const req = {
        is_billing_added: true,
      }
      const response = await axios.patch(`/apiV1/update-user-info/`,req);
      if (response.status === 200) {
        userInfo()
      }
    } catch (error) {
      console.error('Error generating test:', error.response ? error.response.data : error.message);
    }
  }
  return (
    <>
     <PageContainer title="SmartInvestorDeck | Login">
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{
        backgroundImage: `url(${loginIllustration})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "45%"
      }}
    >
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          maxWidth: 400,
          width: "100%",
          padding: 4,
          background: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
        }}
      >
        <Typography variant="h5" sx={{textAlign:"center",mb:1,fontWeight:600}}>Log in to </Typography>
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <img src={Logo} alt="logo" style={{ width: "180px" }} />
          {/* <IconButton sx={{ backgroundColor: "#07659c", color: "white", padding: 3, "&:hover": { backgroundColor: "#07659c" } }}>
            <IconLogin2 color="#fff" size={50} />
          </IconButton> */}
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl variant="standard" fullWidth margin="normal">
            <Typography variant="body2" gutterBottom>Email</Typography>
            <TextField
              id="email-input"
              // autoComplete="off"
              fullWidth
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                  message: "Enter a valid email",
                },
              })}
              onKeyUp={() => { trigger("email"); setApiError(""); }}
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          </FormControl>

          <FormControl variant="standard" fullWidth margin="normal">
            <Typography variant="body2" gutterBottom>Password</Typography>
            <TextField
              id="password-input"
              // autoComplete="new-password"
              fullWidth
              sx={{ "& .MuiOutlinedInput-root": { height: "40px" } }}
              type={showPassword ? "text" : "password"}
              {...register("password", {
                required: "Password is required",
                pattern: {
                  value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                  message: "Please Enter a Valid Password",
                },
              })}
              onKeyUp={() => { trigger("password"); setApiError(""); }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      {showPassword ? <IconEye />  : <IconEyeOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={!!errors.password}
              helperText={errors.password?.message}
              onCopy={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
            />
          </FormControl>

          <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
            {/* <FormControlLabel control={<Checkbox {...register("rememberMe")} />} label="Remember me" /> */}
            <FormControlLabel
              control={
                <Checkbox
                  {...register("rememberMe")}
                  checked={watch("rememberMe") || false}
                />
              }
              label="Remember me"
            />
            <Typography
              variant="body2"
              sx={{ color: "#07659c", cursor: "pointer" }}
              onClick={() => navigate("/forgotpassword")}
            >
              Forgot password?
            </Typography>
          </Box>
          {/* <Box mt={2} display="flex" justifyContent="center">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6Lf0_dsqAAAAABJDHl5yA5Qb3rpdFD9ovNYdkuJ8"
              onChange={(token) => {
                postCaptcha(token);
                setApiError("");
              }} />
          </Box> */}
          {errors.recaptcha && <Typography color="error" variant="body2">{errors.recaptcha.message}</Typography>}
          {Apierror && <Alert severity="error" sx={{ mt: 2 }}>{Apierror}</Alert>}
          {ActivationError && <Alert severity="error" sx={{ mt: 2 }}>{ActivationError}</Alert>}
          {resendmail && <Alert severity="success" sx={{ mt: 2 }}>{resendmail}</Alert>}
          {verify == 'False'&&<Button variant="contained" fullWidth sx={{ mt: 2, bgcolor: "#07659c", height: "40px" }} onClick={ResendEmail} disabled={loading||loading1} className="button2">
              {loading1 ? (
                  <BeatLoader size={24} sx={{ color: '#07659c' }} />
                ) : (
                  <>
                    Resend Email
                  </>
                )}</Button>}
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2,  height: "40px" }} disabled={loading ||loading1} className="button2">
            {loading ? <BeatLoader size={20} color="#fff" /> : <Typography>Sign In</Typography>}
          </Button>
        </form>

        <Typography
          variant="body2"
          textAlign="center"
          sx={{ mt: 2, display: "flex", justifyContent: "center" }}
        >
          Don't have an account?
          <Typography
            variant="body2"
            component="span"
            sx={{ color: "#07659c", ml: 1, cursor: "pointer" }}
            // onClick={() => navigate("/signup")}
            // onClick={() => window.location.href = "https://smartinvestordeck.ai/pricing"}
            onClick={() => window.location.href = "https://pss.pranathiss.com:133/pricing"}
          >
            Register here.
          </Typography>
        </Typography>
      </Paper>
    </Grid>
    </PageContainer>
    <Dialog open={BillingPopup} maxWidth="sm" fullWidth>
      <form onSubmit={BillingSubmit(onBillingSubmit)}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" >
              Billing Address
            </Typography>
            <IconButton onClick={() => setBillingPopup(false)} sx={{ color: 'grey' }}>
              <IconX />
            </IconButton>
        </DialogTitle>

        <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" mb={2}>
        <Alert severity="info">Kindly provide your billing address information in the form below.</Alert>
      </Typography>
          <Grid container spacing={2}>
          <Grid item xs={6}>
    <Typography variant="body2" fontWeight="500" mb={1}>
      First Name <span style={{ color: 'red', fontWeight: 600 }}>*</span>
    </Typography>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="First Name"
      error={!!billingerrors.firstName}
      helperText={billingerrors.firstName?.message}
      {...Billingregister("firstName", {
        required: "First Name is required",
        pattern: {
          value: /^[a-zA-Z\s]{2,}$/,
          message: "First Name should contain only letters",
        },
      })}
    />
  </Grid>

  {/* Last Name */}
  <Grid item xs={6}>
    <Typography variant="body2" fontWeight="500" mb={1}>
      Last Name <span style={{ color: 'red', fontWeight: 600 }}>*</span>
    </Typography>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Last Name"
      error={!!billingerrors.lastName}
      helperText={billingerrors.lastName?.message}
      {...Billingregister("lastName", {
        required: "Last Name is required",
        pattern: {
          value: /^[a-zA-Z\s]+$/,
          message: "Last Name should contain only letters",
        },
      })}
    />
  </Grid>

  {/* Email */}
  <Grid item xs={6}>
    <Typography variant="body2" fontWeight="500" mb={1}>
      Email <span style={{ color: 'red', fontWeight: 600 }}>*</span>
    </Typography>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Email"
      error={!!billingerrors.email}
      helperText={billingerrors.email?.message}
      disabled
      {...Billingregister("email", {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Enter a valid email address",
        },
      })}
    />
  </Grid>

  {/* Mobile Number */}
  {/* <Grid item xs={6}>
    <Typography variant="body2" fontWeight="500" mb={1}>
      Mobile Number <span style={{ color: 'red', fontWeight: 600 }}>*</span>
    </Typography>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Mobile Number"
      error={!!billingerrors.mobile}
      helperText={billingerrors.mobile?.message}
      {...Billingregister("mobile", {
        required: "Mobile number is required",
        pattern: {
          value: /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?){1,2}\d{4}$/,
          message: "Enter a valid phone number",
        },
      })}
      onKeyUp={() => { BillingTrigger("mobile"); }}
    />
  </Grid> */}
              <Grid item xs={6}>
                <Typography variant="body2" fontWeight="500" mb={1}>
                  Mobile Number <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Mobile Number"
                  error={!!billingerrors.mobile}
                  helperText={billingerrors.mobile?.message}
                  inputProps={{ inputMode: "tel", maxLength: 20 }}
                  {...Billingregister("mobile", {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^(?! )[+0-9()\-\s]{8,20}$/, 
                      message: "Enter a valid number (no space at start, allow +()- and digits)",
                    },
                    minLength: {
                      value: 8,
                      message: "Mobile number must be at least 8 characters",
                    },
                    maxLength: {
                      value: 20,
                      message: "Mobile number must not exceed 20 characters",
                    },
                  })}
                  onKeyUp={() => BillingTrigger("mobile")}
                />
              </Grid>


            <Grid item xs={6}>
            <Typography variant="body2" fontWeight="500" mb={1}>
                    Address Line 1 <span style={{ color: 'red',fontWeight:600 }}>*</span>
                </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Street address, P.O. box"
                error={!!billingerrors.addressLine1}
                helperText={billingerrors.addressLine1?.message}
                {...Billingregister("addressLine1", {
                  required: "Address Line 1 is required",
                  pattern: {
                    value: /^[a-zA-Z0-9\s,'-]{3,}$/,
                    message: "Enter a valid address",
                  },
                  maxLength: {
                    value: 50,
                    message: "Address Line 1 cannot exceed 50 characters",
                  },
                })}
                onKeyUp={() => BillingTrigger("addressLine1")}
              />
            </Grid>

            <Grid item xs={6}>
            <Typography variant="body2" fontWeight="500" mb={1}> Address Line 2 </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Apartment, suite, unit, etc."
                error={!!billingerrors.addressLine2}
                helperText={billingerrors.addressLine2?.message}
                {...Billingregister("addressLine2", {
                  pattern: {
                    value: /^[a-zA-Z0-9\s,'-]{3,}$/,
                    message: "Enter a valid address",
                  },
                })}
                onKeyUp={() => BillingTrigger("addressLine2")}

              />
            </Grid>

            

            <Grid item xs={6}>
            <Typography variant="body2" fontWeight="500" mb={1}>
                    State <span style={{ color: 'red',fontWeight:600 }}>*</span>
                </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="State/Province/Region"
                error={!!billingerrors.state}
                helperText={billingerrors.state?.message}
                {...Billingregister("state", {
                  required: "State is required",
                  pattern: {
                    value: /^[a-zA-Z\s]{2,}$/,
                    message: "State should contain only letters",
                  },
                })}
                onKeyUp={() => BillingTrigger("state")}

              />
            </Grid>
            <Grid item xs={6}>
            <Typography variant="body2" fontWeight="500" mb={1}>
                    City <span style={{ color: 'red',fontWeight:600 }}>*</span>
                </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="City"
                error={!!billingerrors.city}
                helperText={billingerrors.city?.message}
                {...Billingregister("city", {
                  required: "City is required",
                  pattern: {
                    value: /^[a-zA-Z\s]{2,}$/,
                    message: "City should contain only letters",
                  },
                })}
                onKeyUp={() => BillingTrigger("city")}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" fontWeight="500" mb={1}>
                    Country <span style={{ color: 'red',fontWeight:600 }}>*</span>
                </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Country"
                error={!!billingerrors.country}
                helperText={billingerrors.country?.message}
                {...Billingregister("country", {
                  required: "Country is required",
                  pattern: {
                    value: /^[A-Za-z]{2,}$/,
                    message: "Country should contain only letters",
                  },
                })}
                onKeyUp={() => BillingTrigger("country")}
              />
            </Grid>
            <Grid item xs={6}>
            <Typography variant="body2" fontWeight="500" mb={1}>
            ZIP<span style={{ color: 'red',fontWeight:600 }}>*</span>
                </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter ZIP code"
                error={!!billingerrors.zipCode}
                helperText={billingerrors.zipCode?.message}
                {...Billingregister("zipCode", {
                  required: "ZIP Code is required",
                  pattern: {
                    value: /^[0-9]{5,6}$/,
                    message: "ZIP Code must be 5 or 6 digits"
                  }
                })}
                onKeyUp={() => { BillingTrigger("zipCode");}}
              />
            </Grid>

            
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button type="submit" variant="contained" color="primary" disabled={loader} className="button2" >
            {loader ? <BeatLoader size={20} color="#fff" /> : <Typography>Submit</Typography>}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
    </>
  );
};

export default LoginForm;
